import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isMarketOpen, isMarketSuspended } from 'sportsbook-helpers';
import withOutcome from 'sportsbook-with-outcome';
import { ErrorBoundary } from 'react-error-boundary';
import { t } from 'bv-i18n';
import { makeGetOutcomes } from 'InPlayOverview/selectors';
import { withCompetitionContext } from 'InPlayOverview/helpers/competition';
import { withNavigationContext } from 'InPlayOverview/helpers/navigation';

import SuspendedMarket from './suspended_market';

const numberOfOutcomesToShow = 5;

const Outcome = withOutcome((props) => {
  if (!props.outcome) {
    return null;
  }

  return (
    <div className="inply-coupon-row">
      <div className="inply-coupon-competition-column">
        <a className="inply-coupon-competition-team" href={props.eventHref}>
          <span className="inply-coupon-team-name">{props.outcome.desc}</span>
        </a>
      </div>
      <div className="inply-coupon-odds-column">
        {isMarketOpen(props.market) && (
          <span
            data-id={props.outcome.id}
            className={`bvs-button-multi-sport ${props.selected ? 'active' : ''}`}
            onClick={props.toggleBetslip}
            clickSource="in-play"
          >
            {props.outcome.formattedPrice}
          </span>
        )}
        {isMarketSuspended(props.market) && <SuspendedMarket />}
      </div>
    </div>
  );
});

export const OutrightOutcomesComponent = ({ outcomes, market, eventHref }) => {
  let outcomesByMarket = outcomes[market.id];
  // remove hidden outcomes
  outcomesByMarket = outcomesByMarket.filter((o) => !o.h);
  // order outcomes by their price
  outcomesByMarket.sort((o1, o2) => (parseFloat(o1.fdp) - parseFloat(o2.fdp)));
  // for outright events the limits are on outcomes
  const limitedOutcomes = outcomesByMarket.slice(0, numberOfOutcomesToShow);

  const outcomeComponents = limitedOutcomes.map((o) => (
    <Outcome
      key={o.id}
      id={o.id}
      market={market}
      eventHref={eventHref}
    />
  ));

  const showAllMarkets = (
    <div className="inply-coupon-row inplay-fulllist-row">
      <a className="inply-coupon-more" href={eventHref}>
        {t('javascript.in_play.show_all_markets')}
      </a>
    </div>
  );

  if (numberOfOutcomesToShow < outcomes.length) {
    outcomeComponents.push(showAllMarkets);
  }

  const FallbackComponent = useCallback(() => showAllMarkets, []);

  return (
    <ErrorBoundary FallbackComponent={FallbackComponent}>
      {outcomeComponents}
    </ErrorBoundary>
  );
};

OutrightOutcomesComponent.propTypes = {
  market: PropTypes.isRequired,
  outcomes: PropTypes.isRequired,
  eventHref: PropTypes.string.isRequired,
};

const makeMapStateToProps = () => {
  const getOutcomes = makeGetOutcomes();

  const mapStateToProps = (state, ownProps) => ({
    outcomes: getOutcomes(state, { markets: [ownProps.market] }),
  });
  return mapStateToProps;
};

export default connect(makeMapStateToProps, null)(
  withNavigationContext(withCompetitionContext(OutrightOutcomesComponent)),
);
